import DateRange from '@/vue-prop-types/DateRange'

export default class DataChunk {
  get startDate() {
    return this.DateRange.start
  }

  get endDate() {
    return this.DateRange.end
  }

  get ConvertToFormat() {
    return this.DateRange.convertToFormat
  }

  constructor({ startDate, endDate, value }) {
    this.value = value
    this.DateRange = DateRange.fromDateRange(startDate, endDate)
  }
}
